export default __webpack_public_path__ + "static/media/password_key.dedf88b9.svg";